// 45-B, paczka PK — konta: ustawienia zaawansowane konta, pigulka i linia limitow w kroku Konta (C0, KONTRAKTY 2026-09-24).
// Poddrzewo `appCampaigns.k45.*`: ten plik edytuje TYLKO jego paczka; klucze PL i EN rownoczesnie.
export const appCampaignsK45 = {
  k45: {
    // Krok Konta: jedna akcja przy pigułce „bez ustawień publikacji” (otwiera arkusz konta w Kontach).
    set: 'Ustaw',
    setLabel: 'Ustaw publikację: {handle}',
    // Jedna siatka tygodnia (reguła 62 MAPY B): własny harmonogram konta i tryb „Tygodniowo” planu.
    week: {
      days: 'pn,wt,śr,czw,pt,sob,nd',
      free: 'wolne',
      perWeek: '{n} / tydz.',
      add: 'Dodaj godzinę: {day}',
      edit: 'Zmień godzinę {time}: {day}',
      remove: 'Usuń godzinę {time}: {day}',
    },
  },
}
